module.exports = __webpack_public_path__ + "media/images/youre-in-demand-dafa9bd4b28d556f424676213278e355.svg";